module.exports = __webpack_public_path__ + "static/img/img5.ef966c6e.png";